export default __webpack_public_path__ + "9989702ba8657cb396c4c3ba6a61ecdd.svg";